<template>
  <div>
    <Errors :errors="errors" />

    <div class="cms-content capped-md">
      Wanneer u bij wensen heeft aangegeven dat u opslagruimte nodig heeft bij Van Beek Inboedelopslag dan wordt hier in de aanbieding rekening mee gehouden. U hoeft hieronder dan ook geen “extra” adresgegevens van onze opslaglocatie te vermelden!
    </div>

    <div class="row row--tight-gutters mt-3 mt-lg-4">
      <div class="col-lg-4 d-flex flex-column">
        <div class="intake__heading mb-2">
          1. Voeg een adres toe
        </div>

        <AddressSidebar />
      </div>

      <div class="col-lg-8 d-flex flex-column mt-3 mt-lg-0">
        <div class="intake__heading mb-2">
          2. Vul adresgegevens in
        </div>

        <AddressContent />
      </div>
    </div>

    <button
      type="button"
      class="btn btn--primary mt-3"
      @click="() => setActiveTab('intake')"
    >
      Volgende stap
    </button>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Errors from '@/intake/components/Errors.vue';
import AddressSidebar from '@/intake/components/AddressSidebar.vue';
import AddressContent from '@/intake/components/AddressContent.vue';

export default {
  components: {
    Errors,
    AddressSidebar,
    AddressContent,
  },

  computed: {
    ...mapGetters({
      errors: 'addressErrors',
    }),
  },

  methods: {
    ...mapMutations({
      setActiveTab: 'setActiveTab',
    }),
  },
};
</script>
